<template>
  <main class="event-quota">
    <h1>Fotos do Evento</h1>
    <p>Peça ao organizador um código de recarga para continuar.</p>
    <p v-if="config">Saldo disponível: <strong>{{ config.available }}</strong> fotos</p>
    <p v-if="pending" role="status">Há um envio pendente de conferência. O administrador precisa conferir antes de outro atendimento.</p>
    <form @submit.prevent="recarregar">
      <label>Código de recarga
        <input v-model="code" maxlength="24" autocomplete="off" autocapitalize="characters" :disabled="busy || !!requestId" @input="normalizar" />
      </label>
      <div class="event-quota__keyboard" v-if="!requestId">
        <button v-for="key in alphabet" :key="key" type="button" @click="code = (code + key).slice(0, 20)">{{ key }}</button>
        <button type="button" @click="code = code.slice(0, -1)">Apagar</button>
      </div>
      <button :disabled="busy || code.length !== 20">{{ busy ? "Verificando…" : "Aplicar recarga" }}</button>
    </form>
    <p v-if="error" role="alert">{{ error }}</p>
    <button type="button" :disabled="busy" @click="atualizar">Verificar saldo e conferência</button>
    <button type="button" :disabled="busy" @click="$router.push('/cabine/home')">Voltar</button>
    <p class="event-quota__note">A contagem usa fotos aceitas pelo serviço de impressão. Comum: 1 por cópia · Polaroid: 2 por folha · 3×4: 1 por cartela.</p>
  </main>
</template>
<script>
import { refreshPhotoQuota, reconcileQuotaReservations, quotaLocalState, redeemPhotoQuota } from "@/service/eventPhotoQuota";
import { eventRequestId } from "@/service/eventAttendance";
export default {
  name: "EventPhotoQuota",
  data: () => ({ code: "", requestId: null, busy: false, error: "", config: null, pending: false, alphabet: "0123456789ABCDEF".split("") }),
  mounted() {
    const pending = quotaLocalState(this.id()).pendingTopup;
    if (pending) { this.code = pending.code; this.requestId = pending.requestId; }
    this.atualizar();
  },
  methods: {
    id() { return this.$store.getters["totem/getTotem"]?.id; },
    normalizar() { this.code = this.code.toUpperCase().replace(/[^A-F0-9]/g, "").slice(0, 20); },
    async atualizar() {
      if (this.busy) return;
      this.busy = true; this.error = "";
      try {
        await reconcileQuotaReservations(this.id());
        this.config = await refreshPhotoQuota(this.id(), false);
        this.pending = Object.values(quotaLocalState(this.id()).reservations).some((item) => ["PENDING", "DISPATCHING", "UNCERTAIN", "ACCEPTED"].includes(item.status)
          || item.status === "RESERVED" && !!item.paymentRequestId);
      } catch (_) { this.error = "Não foi possível conferir agora. Verifique a internet ou peça ajuda ao organizador."; }
      finally { this.busy = false; }
    },
    async recarregar() {
      if (this.busy || this.code.length !== 20) return;
      this.busy = true; this.error = ""; this.requestId = this.requestId || eventRequestId();
      try {
        this.config = await redeemPhotoQuota(this.id(), this.code, this.requestId);
        this.code = ""; this.requestId = null;
      } catch (error) {
        this.error = error?.response?.data?.message || "Não foi possível confirmar a recarga. Tente novamente com o mesmo código.";
        if ([400, 403, 404, 409].includes(error?.response?.status)) this.requestId = null;
      } finally { this.busy = false; }
    },
  },
};
</script>
<style scoped>
.event-quota { min-height: 100vh; display: flex; flex-direction: column; align-items: center; justify-content: center; gap: 22px; padding: 32px; text-align: center; background: #fff5fa; color: #542548; }
.event-quota h1 { font-size: 42px; font-weight: 700; }
.event-quota p { font-size: 24px; max-width: 850px; }
.event-quota form, .event-quota label { display: flex; flex-direction: column; align-items: center; gap: 16px; font-size: 24px; }
.event-quota input { width: 560px; max-width: 90vw; padding: 16px; border: 2px solid #db2777; border-radius: 12px; text-align: center; font-size: 28px; letter-spacing: 3px; }
.event-quota button { background: #db2777; color: white; padding: 16px 28px; border: 0; border-radius: 12px; font-size: 22px; }
.event-quota button:disabled { opacity: .5; }
.event-quota__keyboard { display: grid; grid-template-columns: repeat(8, 1fr); gap: 10px; }
.event-quota .event-quota__note { font-size: 18px; }
</style>
